export const META_TAG_BASE_URL = "base-url";
export const META_TAG_STATIC_PATH = "static-path";
export const META_TAG_STRIPE_KEY = "s-key";

export const getMetaTag = (tagName) => {
  const metaElm = document.querySelector(`meta[name='${tagName}']`);
  return metaElm != null && typeof metaElm !== 'undefined' ? metaElm.getAttribute('content') : '';
};
